import React from "react";
import Link from "next/link";
import { getHost, getSubjectListUrl } from "@/utils/URL";
import classNames from "classnames";
import Icon from "@/read-ui/Icon";
import { IChevronRight } from "webnovel-icons";
import styles from "./index.module.scss";
import List from "../../SubjectList/List";

export type PopularTagsProps = {
  title: string;
  list: {
    topicName?: string;
    searchWord?: string;
    topicId?: number;
  }[];
} & React.HTMLAttributes<HTMLDivElement>;

const PopularTags = (props: PopularTagsProps) => {
  const { className = "", list, title } = props;

  if (!list?.length) {
    return null;
  }

  return (
    <section className={className}>
      {title && (
        <div className={classNames(styles.header, "mb12")}>
          <div className="bsbb fi m0 p0 fs16 lh20 fw500 ell c_l fl">
            {title}
          </div>
          <Link
            className={classNames(styles.extraRight, "c_m fs14")}
            href={getHost() + getSubjectListUrl()}
          >
            More
            <Icon size={20} Svg={IChevronRight} />
          </Link>
        </div>
      )}
      <div>
        <List
          list={list.map((item) => ({
            ...item,
            searchWord: item.topicName,
          }))}
          className={styles.list}
        />
      </div>
    </section>
  );
};

export default PopularTags;
